import { E2NTableCell } from '../../../../components/Table';
import { memo } from 'react';
import { Mitarbeiter } from '../../entities';
import { MitarbeiterAvatar } from '../Avatar/MitarbeiterAvatar';

export const MitarbeiterCell = memo(function MitarbeiterCell({
  mitarbeiter,
}: {
  mitarbeiter: Mitarbeiter;
}) {
  return (
    <E2NTableCell className="rounded-l-lg w-40" isBorderVisible>
      <div className="flex gap-4 items-center font-semibold ">
        <MitarbeiterAvatar
          vorname={mitarbeiter.vorname}
          nachname={mitarbeiter.nachname}
          bildUrl={mitarbeiter.bildUrl}
          extern={mitarbeiter.extern}
        />
        <span className="truncate md:max-w-40 max-w-28">
          {`${mitarbeiter.vorname} ${mitarbeiter.nachname}`}
        </span>
      </div>
    </E2NTableCell>
  );
});
